import React from 'react';
import '../App.css';
import pic from "../assets/pic.jpg";
import liLogo from "../assets/linkedin.png";
import ghLogo from "../assets/github.png";

function About() {
  return (
    <div className="App">
      <header className="App-header">
          <p>
              <a href="./*"><img src={pic} alt="David and Charlie" className="Photo"></img></a>
              <div className="About">
                  <p>I'm an engineer, problem solver, tinkerer, and dog lover.</p>
                  <p>For as long as I can remember, I have enjoyed solving engineering problems.
                      Over my career these problems have ranged from mechanical to virtual, from
                      problems of scale to problems of logistics. At the end of the day, what I
                      value most in a solution is simplicity and ease of use.</p>
                  <p>The common thread through my career has been working to make peoples lives
                      easier through tooling and automation. As one of the founding Engineers at
                      cloudtamer.io (now Kion), my goal was to make it easier for our customers to govern
                      their cloud infrastructure. It was exciting to automate solutions that could scale
                      across a customer's entire cloud presence to allow them to automate security
                      and maintain visibility into their cloud spend. </p>
                  <p>Most recently, at Sayari I partnered with a single colleague to rewrite our entire
                      <a href="https://docs.sayari.com"> docs site </a>to make it more usable for our customers
                      while at the same time dramatically reducing the level of effort needed to keep it up to
                      date. On top of this, the tool we used (<a href="https://buildwithfern.com">Fern</a>)
                      also allowed us to generate multi-platform SDKs with almost no further effort.</p>
                  <p>I give these examples simply to illustrate how much I enjoy solving problems in a
                      way that benefits all stakeholders. If you have a problem that needs a technical solution,
                      please don't hesitate to reach out.</p>
              </div>

              <br/>
              <a href="https://www.linkedin.com/in/davidakonigsberg"><img src={liLogo} alt="David's LinkedIn Profile"
                                                                          className="external-logo-link"></img></a>
              <a href="https://github.com/davidkonigsberg"><img src={ghLogo} alt="David's GitHub Profile"
                                                                className="external-logo-link"></img></a>
          </p>
      </header>
    </div>
  );
}

export default About;
